<template>
  <div id="app">
    <div>
      <img src="https://oddfellow.se/graphics/top/logo.gif" />
      <div id="nav">
        <div>
          <font-awesome-icon icon="link" /> 
          <router-link to="/">24 Birger Jarl</router-link>
        </div>
        <div>
          <font-awesome-icon icon="link" /> 
          <router-link to="/information">Information</router-link>
        </div>
        <div>
          <font-awesome-icon icon="link" /> 
          <router-link to="/external">Externa resurser</router-link>
        </div>
        <div>
          <font-awesome-icon icon="lock" /> 
          <router-link to="/loge">Logen</router-link>
        </div>
        <div>
          <font-awesome-icon icon="lock" /> 
          <router-link to="/brothers">Bröder</router-link>
        </div>
        <div>
          <font-awesome-icon icon="lock" /> 
          <router-link to="/committees">Utskott</router-link>
        </div>
        <div>
          <font-awesome-icon icon="lock" /> 
          <a href="http://headless.24bj.se/public">Admin</a>
        </div>
        <div id="login">
          <Userstats id="userstats" />
        </div>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import logoUrl from "@/assets/img/logo.jpg";
import Userstats from "./components/userStats";

export default {
  name: "Login",
  components: { Userstats },
  data: () => {
    return {
      username: null,
      password: null,
      message: null
    };
  },
  computed: {
    logo() {
      return logoUrl;
    }
  }
};
</script>

<style lang="scss">
/*
grå rgb(198,199,200)
Varmrött rgb(218, 41, 28)
Rebecca rgb(242,198,207)
Varmbeige rgb(230, 230, 195)
Mintgrön rgb(213, 240, 180)
Läderröd rgb(130, 0, 0)
Läderbrun rgb(104, 61, 0)
Ljus kanel rgb(164, 144, 88)
Gråbeige rgb(171, 173, 166)
*/

#app {
  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 16px;
  padding: 0 0 0 0.5em;
  background:  rgb(218, 41, 28);
  
  > div{
    padding: 1em;
    background: white;
    min-height: 96vh;
  }
  > img {
    width: 5em;
  }
  a {
    font-weight: bold;
    text-decoration: none;
    color: rgb(130, 0, 0);
  }
  a::selection {
    color: rgb(218, 41, 28);
  }
  button {
    color: rgb(130, 0, 0);
    font-weight: 500;
    background: white;
    border-radius: 5px;
  }
  div > img{
    margin-bottom: 1em;
  }
}
#nav {
  display: flex;
  flex-direction: column;

  > div {
    height: 1em;
    margin: 0.2em 0;
    padding: 1rem;
    background: rgb(230, 230, 195);
    border-bottom: 2px;
    max-width: 350px;
  }
  > div:last-child {
    height: 5em;
  }
  .logoImg {
    width: 5em;
  }
  svg{
    margin-right: 1em;
  }
}
#login div{
  padding: 0;
  margin: 0;
}
.articles {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
}
input,
button {
  padding: 1em;
  margin-right: 1em;
}
@media print {
  #nav,
  #userstats {
    display: none;
  }
  #app > div > img {
    display:none;
  }
  .matrikel {
    font-size: 16px;
  }
  .matrikel img {
    display: block;
  }
}
</style>
